module.exports = __webpack_public_path__ + "img/no-tokens-found-136px.cbf02e8.png";